module.exports = __webpack_public_path__ + "assets/img/LJ-Hooker-Pillar-Page-Resource-w540.e12dbe0e.webp";